/**
 *
 * Asynchronously loads the component for PdfExportButton
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/claim-export-button/loadable.js